/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LevelPassWindow, {
    "progress": {
        x: { align: "right", dx: -6 }
    },

    window: {
        padding: {
            top: 100,
            bottom: 40
        }
    }
});
